
import Switchery from "../../../../vendor/assets/javascripts/limitless_kit/plugins/forms/styling/switchery.min";

globalThis.Switchery = Switchery;
